import { ExternalLink } from 'lucide-react';
import { useEffect, useRef } from 'react';
import { useState } from 'react';
import { Calendar } from 'lucide-react';
import axios from 'axios';
import { QuizrrStepper } from './Stepper/QuizrrStepper';
import ProgressAnalysis from './ProgressAnalysis/ProgressAnalysis';
import AllTestsList from './AllTestsList/AllTestsList';
import Resources from './Resources/Resources';
import { Badge } from '../components/ui/badge';
import { TestSchedule } from './Calender/TestSchedule';

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../components/ui/selectDashboard';
import { useNavigate } from 'react-router-dom';
import TopHeader from '../Layout/TopHeader';
import { OnboardingModal } from '../Auth/AuthOnboarding/OnboardingModal';
import { HeartIcon } from '@phosphor-icons/react';
import { AppLayout } from '../Layout/AppLayout';
import { usePackStorage } from '../Layout/usePackStorage';
import Banner from '../components/generic/Banner';
import NoTestSeries from '../TestSeries/NoTestSeriesBought/NoTestSeries';
import BannerDesktop from '../../../../apps/frontend/public/img/banner-desktop.webp';
import BannerMobile from '../../../../apps/frontend/public/img/banner-mobile.webp';
import ExploreSection from './ExploreSection/ExploreSection';

function Dashboard() {
  const { purchasedPacks, freePacks, selectedPack, handlePackChange } = usePackStorage();

  const [isExpanded, setIsExpanded] = useState(false);
  const [userProfile, setUserProfile] = useState(JSON.parse(localStorage.getItem('userProfile')));
  const [isLoading, setIsLoading] = useState(true);
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [isHelloBarVisible, setIsHelloBarVisible] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if HelloBar was previously closed
    const isClosed = sessionStorage.getItem('hellobarClosed');
    if (isClosed) {
      setIsHelloBarVisible(false);
    }
  }, []);

  const handleHelloBarClose = () => {
    setIsHelloBarVisible(false);
  };

  const savePackIdToStorage = (packId) => {
    try {
      localStorage.setItem('selectedPackId', packId);
    } catch (error) {
      console.error('Error saving pack ID to localStorage:', error);
    }
  };

  const dashboardScrollRef = useRef(null);

  const user = JSON.parse(localStorage.getItem('userProfile'));

  useEffect(() => {
    const fetchPacks = async () => {
      const apiUrl = `/api/packs/v3`;
      try {
        setIsLoading(true);
        const response = await axios.get(apiUrl);
        const packs = response?.data?.data?.purchasedPacks;
        const notPurchasedPacks = response?.data?.data?.notPurchasedPacks;

        if (!packs || !packs?.length) {
          savePackIdToStorage(notPurchasedPacks[0]._id);
          setSelectedPack(notPurchasedPacks[0]);
        } else return;

        if (packs?.length > 0) {
          const savedPackId = localStorage.getItem('selectedPackId');
          if (savedPackId && packs?.length > 0) {
            const savedPack = packs.find((pack) => pack._id === savedPackId);
            if (savedPack) {
              setSelectedPack(savedPack);
            } else {
              savePackIdToStorage(packs[0]._id);
              setSelectedPack(packs[0]);
            }
          } else {
            savePackIdToStorage(packs[0]._id);
            setSelectedPack(packs[0]);
          }
        }
      } catch (error) {
        if (error.response) {
          console.error('Error response data:', error.response.data);
          console.error('Error response status:', error.response.status);
          console.error('Error response headers:', error.response.headers);
        } else if (error.request) {
          console.error('Error request:', error.request);
        } else {
          console.error('Error message:', error.message);
        }
      } finally {
        setIsLoading(false);
      }
    };

    // fetchPacks();
  }, [navigate]);

  useEffect(() => {
    async function checkOnboardingStatus() {
      const res = await axios.get('/api/auth/user');
      const user = res?.data?.data;
      const hasCompletedOnboarding = user?.learningModeDetails && user?.isOnboardingV2Done;
      if (!hasCompletedOnboarding) {
        setShowOnboarding(true);
      }
    }
    checkOnboardingStatus();
  }, []);

  const handleOnboardingComplete = () => {
    setShowOnboarding(false);
    if (!packs || packs.length === 0) {
      navigate('/no-test-series-purchased');
    } else return;
  };

  const [isInitialBounce, setIsInitialBounce] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsInitialBounce(false);
    }, 4500);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    window.webengage.track('Viewed Dashboard', {
      'User Id': user?.email,
    });
  }, []);

  if (!purchasedPacks?.length && !freePacks?.length) {
    return <NoTestSeries />;
  }

  return (
    <AppLayout purchasedPacks={purchasedPacks} selectedPack={selectedPack} onPackChange={handlePackChange}>
      <div
        ref={dashboardScrollRef}
        className={`
           h-screen overflow-y-scroll
          transition-all duration-700 ease-in-out w-[1090px]
          ${!isExpanded ? 'flex justify-center' : ''}
        `}
      >
        <div
          className={`
            flex flex-col py-4
            transition-all duration-700 ease-in-out
            w-full
            pt-8
          `}
        >
          {/* HelloBar with negative margin to cancel out parent padding when expanded, or positioned absolutely when collapsed */}
          {/* <div
            className={`
              ${!isExpanded ? '' : '-mx-4 md:-mx-4 -my-4'}
              ${isHelloBarVisible ? 'mb-8' : ''}
              lg:mb-0
            `}
          >
            <HelloBar isCollapsed={!isExpanded} onClose={handleHelloBarClose} />
          </div> */}

          <div className="">
            <Banner />
          </div>

          <TopHeader />

          <div className="relative mb-8 mt-2 md:mt-0 flex-shrink-0 px-4 md:px-2 flex justify-between w-full items-center">
            {purchasedPacks?.length > 0 && (
              <Select value={selectedPack?._id} onValueChange={handlePackChange}>
                <SelectTrigger
                  size="lg"
                  className="min-w-[120px] max-w-[90vw] w-fit !bg-[var(--q3-surface-default)] text-[var(--q3-neutral-default)] cursor-pointer rounded-4xl shadow-none py-1 lg:py-2"
                >
                  <SelectValue placeholder={<div className="font-semibold">Select Test</div>} />
                </SelectTrigger>

                <SelectContent className="rounded-xl bg-[var(--q3-surface-default)] shadow-lg w-(--radix-select-trigger-width) min-w-(--radix-select-trigger-width)">
                  <SelectGroup>
                    {purchasedPacks?.map((each) => {
                      const isSelected = selectedPack?._id === each._id;
                      return (
                        <SelectItem
                          className={`px-4 py-4 font-semibold cursor-pointer w-full ${
                            isSelected
                              ? 'bg-[var(--q3-neutral-default)] text-[var(--q3-neutral-default_inverted)]'
                              : 'bg-[var(--q3-surface-default)] text-[var(--q3-neutral-default)]'
                          }`}
                          key={each._id}
                          value={each?._id}
                        >
                          <div className="flex items-center gap-2 w-full">
                            <img alt="img" src={each?.icon || '/placeholder.svg'} className="h-5 w-5 md:h-6 md:w-6" />
                            <p className="font-medium whitespace-nowrap" style={{ fontSize: '16px' }}>
                              {/* Desktop text (hidden on small screens) */}
                              <span className="hidden sm:inline">{each?.title}</span>

                              {/* Mobile text (visible only on small screens) */}
                              <span className="inline sm:hidden">
                                {each?.shortTitle || each?.exam?.title || each?.title}
                              </span>
                            </p>
                          </div>
                        </SelectItem>
                      );
                    })}
                    <SelectItem
                      value="view-other-tests"
                      className="px-4 py-4 cursor-pointer text-[var(--q3-neutral-default)] w-full"
                    >
                      <div className="flex items-center justify-between w-full gap-3">
                        <span className="text-sm font-medium text-[var(--q3-neutral-default)]">
                          View Other Test Series
                        </span>
                        <ExternalLink className="w-4 h-4 text-[var(--q3-neutral-default)] flex-shrink-0" />
                      </div>
                    </SelectItem>
                  </SelectGroup>
                </SelectContent>
              </Select>
            )}
            {purchasedPacks?.length > 0 && (
              <div
                style={{ right: -13.5 }}
                className="cursor-pointer flex lg:hidden"
                onClick={() => setIsExpanded(!isExpanded)}
              >
                <Badge variant="outline" className="border-2 items-center gap-1 rounded-3xl cursor-pointer py-1 px-3">
                  <Calendar style={{ width: 'auto', height: '20px' }} />
                </Badge>
              </div>
            )}
          </div>

          <div className="mb-30">
            {purchasedPacks?.length > 0 && (
              <div>
                <QuizrrStepper packId={selectedPack?._id} />
              </div>
            )}
            {purchasedPacks?.length > 0 && (
              <div>
                <ProgressAnalysis packId={selectedPack?._id} />
              </div>
            )}
            <div className={`${freePacks?.length > 0 ? 'mt-0' : 'mt-5'}`}>
              <AllTestsList packId={selectedPack?._id} />
            </div>
            <div className="mt-10">
              {selectedPack?.resources && <Resources packId={selectedPack?._id} packData={selectedPack} />}
            </div>
            <div className="mt-10">
              <ExploreSection />
            </div>
            <div className="text-[28px] md:text-[40px] text-[var(--q3-neutral-light-v3)] font-extrabold p-2 mt-10 mb-24 md:mb-0 leading-snug text-start">
              <p className="text-wrap">
                Made with&nbsp;
                <HeartIcon
                  weight="fill"
                  className={`inline-block w-8 h-8 align-middle text-[var(--q3-danger-normal)] throb-on-hover ${
                    isInitialBounce ? 'throb-animation' : ''
                  }`}
                />
                &nbsp;by the Quizrr team, just for aspirants like you.
              </p>
              <p className="mt-4 text-3xl font-bold opacity-35" style={{ fontFamily: "'Caveat', cursive" }}>
                #PaperPhodnaHai
              </p>
            </div>
          </div>
        </div>
      </div>

      {purchasedPacks?.length > 0 && (
        <div
          className={`
        flex-shrink-0 h-screen overflow-hidden
        transition-all duration-700 ease-in-out
        ${isExpanded ? 'w-[320px] lg:w-[320px]' : 'sm:w-0'}
      `}
        >
          <div className="h-full">
            <TestSchedule isExpanded={isExpanded} setIsExpanded={setIsExpanded} />
          </div>
        </div>
      )}

      {/* Onboarding Modal */}
      <OnboardingModal open={showOnboarding} onComplete={handleOnboardingComplete} />
    </AppLayout>
  );
}

export default Dashboard;
